
/*

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

  */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './context/AuthContext';

const isStandalone = process.env.REACT_APP_STANDALONE === 'true';

if (isStandalone) {
  // In standalone mode, importa AppStandalone
  import('./AppStandalone').then(({ default: AppStandalone }) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <AuthProvider>
          <AppStandalone />
        </AuthProvider>
      </React.StrictMode>
    );
  });
} else {
  // In embedded mode, importa App normale
  import('./App').then(({ default: App }) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <AuthProvider>
          <App />
        </AuthProvider>
      </React.StrictMode>
    );
  });
}